import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Text, Stack, Icon } from '@iqueue/iq-ui';
import Field from '../components/ui/Field';
import { api } from '../lib/api';
import AuthLayout from './AuthLayout';



export default function ChangePasswordPage({ onAuthed }) {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const [username, setUsername] = useState(state.username || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError('');
    if (newPassword !== confirm) { setError('Пароли не совпадают'); return; }
    if (newPassword.length < 8) { setError('Пароль слишком короткий (минимум 8 символов)'); return; }
    setBusy(true);
    try {
      await api.changePassword(username, currentPassword, newPassword);
      await onAuthed();
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title={state.mustChange ? 'Нужно сменить пароль' : 'Смена пароля'}
      footer={<Button variant="text" startIcon={<Icon name="arrow_back" />} render={<Link to="/login" />}>К входу</Button>}
    >
      <Stack gap={200} render={<form onSubmit={submit} />}>
          {state.mustChange && (
            <Text variant="body-small" muted>Для этого аккаунта требуется сменить пароль перед первым входом.</Text>
          )}
          <Field label="Имя пользователя" value={username} onChange={setUsername} required autoComplete="username" />
          <Field label="Текущий пароль" type="password" value={currentPassword} onChange={setCurrentPassword} autoFocus={!!state.username} required autoComplete="current-password" />
          <Field label="Новый пароль (мин. 8 символов)" type="password" value={newPassword} onChange={setNewPassword} required autoComplete="new-password" />
          <Field label="Повторите новый пароль" type="password" value={confirm} onChange={setConfirm} required autoComplete="new-password" />
          {error && <Text variant="body-small" >{error}</Text>}
          <Button type="submit" disabled={busy || !username || !currentPassword || !newPassword} >
            {busy ? 'Сохранение…' : 'Сменить пароль и войти'}
          </Button>
      </Stack>
    </AuthLayout>
  );
}
